import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type AdminState = {
  sidebarOpen: boolean
  soundMuted: boolean
}

const initialState: AdminState = {
  sidebarOpen: false,
  soundMuted: false,
}

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload
    },
    toggleSound: (state) => {
      state.soundMuted = !state.soundMuted
    },
  },
})

export const {
  setSidebarOpen,
  toggleSound,
} = adminSlice.actions

export default adminSlice.reducer
